(() => {
  const markers = [...document.querySelectorAll('[data-nomna-collection-menu]')];
  if (!markers.length) return;
  const key = (value) => String(value).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const pinExisting = () => {
    for (const marker of markers) {
      if (!marker.dataset.bestRoomUrl) continue;
      const list = marker.parentElement;
      const roomPath = new URL(marker.dataset.bestRoomUrl, location.origin).pathname;
      if (marker.dataset.managedBestRoom === 'true') {
        for (const link of list.querySelectorAll('a[href*="/collections/"]')) {
          const path = new URL(link.href, location.origin).pathname;
          if (path === roomPath || !path.includes('-best-sellers')) continue;
          const item = link.closest('li');
          if (item && list.contains(item)) item.remove();
        }
      }
      const roomLink = [...list.querySelectorAll('a[href]')].find((link) => new URL(link.href).pathname === roomPath);
      const item = roomLink?.closest('li');
      if (item && item.parentElement === list && item !== list.firstElementChild) list.insertBefore(item, list.firstElementChild);
    }
  };
  const matches = (entry, topic, menu, managedBestRoom) => {
    if (entry.best_child) return false;
    if (entry.best_room) return entry.best_room === topic || entry.best_room === menu;
    if (managedBestRoom && entry.handle.includes('-best-sellers')) return false;
    if (entry.handle.endsWith('-best-sellers')) return entry.handle === `${topic}-best-sellers`;
    if (Array.isArray(entry.topics)) {
      return entry.topics.some((value) => {
        const tag = key(value);
        return tag === topic || tag === menu || (topic === 'halloween' && tag === 'hlw');
      });
    }
    if (!['halloween', 'christmas', 'autumn'].includes(topic)) return false;
    const name = key(`${entry.title}-${entry.handle}`);
    return name.includes(topic) || (topic === 'christmas' && name.includes('xmas'));
  };
  const append = (entries) => {
    for (const marker of markers) {
      const list = marker.parentElement;
      const urls = new Set([...list.querySelectorAll('a[href]')].map((link) => new URL(link.href).pathname));
      for (const entry of entries) {
        if (!matches(entry, marker.dataset.topic, marker.dataset.menu, marker.dataset.managedBestRoom === 'true')) continue;
        const url = new URL(entry.url, location.origin);
        if (url.origin !== location.origin || !url.pathname.startsWith('/collections/') || urls.has(url.pathname)) continue;
        const item = document.createElement('li');
        item.dataset.nomnaTopic = marker.dataset.topic;
        const link = document.createElement('a');
        link.className = marker.dataset.linkClass;
        link.href = url.pathname;
        link.textContent = entry.title;
        item.append(link);
        if (entry.best_room || entry.handle === `${marker.dataset.topic}-best-sellers`) {
          list.insertBefore(item, list.firstElementChild);
        } else {
          list.insertBefore(item, marker);
        }
        urls.add(url.pathname);
      }
    }
    pinExisting();
  };
  pinExisting();
  const load = async () => {
    let pages = 1;
    for (let page = 1; page <= pages; page++) {
      const url = new URL(`${window.Shopify?.routes?.root || '/'}collections`, location.origin);
      url.searchParams.set('section_id', 'nomna-collection-index');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection index unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = document.querySelector('[data-nomna-collection-index]');
      if (!node) throw new Error('Collection index missing');
      const data = JSON.parse(node.textContent);
      if (!Array.isArray(data.items) || !Number.isInteger(data.pages) || data.pages < 0) throw new Error('Invalid collection index');
      pages = data.pages;
      append(data.items);
    }
  };
  // Server links remain usable if the request fails; retry on the next menu interaction.
  let loading;
  const start = () => {
    if (!loading) loading = load().catch(() => { loading = null; });
  };
  start();
  for (const marker of markers) {
    const menu = marker.closest('details');
    menu?.addEventListener('toggle', start);
  }
})();
